module.exports = __webpack_public_path__ + "static/media/home_logo@2x.c79b1f8e.png";